import { Component, Input, OnInit } from "@angular/core";
import { Tools } from "@comunicare/comunicare-helper";
import { IObservationInfo, PatientDataInfoPeriod } from "@comunicare/comunicare-interfaces";
import moment from "moment";

@Component({
  selector: "app-observations-simplified",
  templateUrl: "./observations-simplified.component.html",
  styleUrls: ["./observations-simplified.component.scss"],
})
export class ObservationSimplifiedComponent implements OnInit {
  @Input() observations: IObservationInfo[];
  @Input() observationPeriod: PatientDataInfoPeriod;

  public PatientDataInfoPeriod = PatientDataInfoPeriod;
  public groupedObservations: {
    date: string;
    observations: IObservationInfo[];
  }[] = [];
  public numberOfPeriods = 0;

  ngOnInit(): void {
    if (Tools.isDefined(this.observationPeriod) && this.observationPeriod !== PatientDataInfoPeriod.LAST_AVAILABLE) {
      this.groupObservationsByDate();

      this.numberOfPeriods = Number(this.observationPeriod) + 1;
    }
  }

  private groupObservationsByDate(): void {
    if (!this.observations?.length) {
      return;
    }

    const observationsMap: Record<string, IObservationInfo[]> = {};

    this.observations.forEach((observation) => {
      const dateKey = moment(observation.issued).format("YYYY-MM-DD");
      if (!observationsMap[dateKey]) {
        observationsMap[dateKey] = [];
      }
      observationsMap[dateKey].push(observation);
    });

    this.groupedObservations = [];
    for (const date in observationsMap) {
      this.groupedObservations.push({
        date: date,
        observations: observationsMap[date],
      });
    }

    this.groupedObservations.sort((a, b) => {
      return moment(b.date).valueOf() - moment(a.date).valueOf();
    });
  }
}
